module.exports = __webpack_public_path__ + "img/pr-3.b0d64851.png";